import { axios } from '@Root/API'

export const exportCSV = payload => {
  return axios.get(`/advanced-search/export/csv`, {
    params: { ...payload },
  })
}
